import { motion } from 'framer-motion';
import styled from 'styled-components';

import { accordionTransition, AccordionVariant, accordionVariants } from '@pkg/motion';
import { designColor, styledInteraction, styledTypography } from '@pkg/primitives';

import { tokens } from './ErrorMessage.tokens';

export const StyledErrorMessage = styled(motion.div).attrs({
    variants: accordionVariants,
    initial: AccordionVariant.Hidden,
    animate: AccordionVariant.Show,
    exit: AccordionVariant.Hidden,
    transition: accordionTransition,
})`
    // Necesasry to create a "space before" in place of a
    // gap/margin/padding (required for smooth height animation).
    &::before {
        ${styledInteraction.interactionDisable};
        content: '';
        display: block;
        width: 100%;
        height: ${tokens.spaceBefore}px;
    }
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.fontSize}px;
    letter-spacing: -0.02em;
    line-height: 1.1;
    color: ${designColor.red};
`;
